import { useSelector } from "react-redux";
import { Selectors as UserSelectors } from "@/store/user/selectors";

export const useUserId = (): Maybe<string> => {
  return useSelector(UserSelectors.getUserId) || null;
};
